import { api } from './api';
import { AuthUser, LoginRequest, LoginResponse } from '@/types/api.types';

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<AuthUser>('/api/v1/auth/login-dashboard', credentials);

    // Check if login actually succeeded
    if (!response.success || !response.data) {
      throw new Error(response.message || 'فشل تسجيل الدخول');
    }

    // Store user info only (JWT is in HTTP-only cookie)
    const user = response.data;
    localStorage.setItem('auth_user', JSON.stringify(user));

    return user;
  }

  async getProfile(): Promise<AuthUser> {
    const response = await api.get<AuthUser>('/api/v1/auth/profile');
    return response.data;
  }

  async forgotPassword(email: string): Promise<void> {
    await api.post('/api/v1/auth/forgot-password', { email });
  }

  async logout(callBackend: boolean = true): Promise<void> {
    try {
      if (callBackend) {
        // Call backend to clear cookie
        await api.post('/api/v1/auth/logout', {});
      }
    } catch (error) {
      // Even if logout fails, clear local data
    } finally {
      localStorage.removeItem('auth_user');
    }
  }

  getToken(): string | null {
    // Token is in HTTP-only cookie, not accessible from JS
    return null;
  }

  getUser(): AuthUser | null {
    const userStr = localStorage.getItem('auth_user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }

  isAuthenticated(): boolean {
    // Check if user data exists (cookie auth is handled by backend)
    return !!this.getUser();
  }
}

export const authService = new AuthService();
